module.exports = "/_next/static/images/72094855c033314c77d8104e0faafd59-woman-using-cellphone@1.5x.jpg.webp";